import React from 'react';
import {
  TextField,
  Grid,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio
} from '@mui/material';
import { SavedSecretField } from './SavedSecretField';
import { isConcealedSecret } from '../sftpFileFeedConfig';

export function secretHasKey(connection) {
  return (
    isConcealedSecret(connection.privateKey) ||
    (typeof connection.privateKey === 'string' && connection.privateKey !== '')
  );
}


export const SftpCredentialsFields = ({ connection, onChange }) => {
  const mode = connection.type === '1password_item' ? 'onepassword' : 'direct';
  const keyMode = secretHasKey(connection) ? 'key' : 'password';

  const switchMode = (newMode) => {
    if (newMode === 'onepassword') {
      onChange({
        type: '1password_item',
        '1password_item_path': ''
      });
    } else {
      onChange({
        host: '',
        port: 22,
        username: '',
        password: ''
      });
    }
  };

  const switchKeyMode = (newMode) => {
    const next = { ...connection };
    if (newMode === 'key') {
      delete next.password;
      onChange({ ...next, privateKey: '', passphrase: '' });
    } else {
      delete next.privateKey;
      delete next.passphrase;
      onChange({ ...next, password: '' });
    }
  };

  return (
    <>
      <FormControl sx={{ marginBottom: '16px' }}>
        <RadioGroup onChange={(e) => switchMode(e.target.value)} row value={mode}>
          <FormControlLabel
            control={<Radio />}
            label="Enter connection details"
            value="direct"
          />
          <FormControlLabel
            control={<Radio />}
            label="Reference a 1Password item"
            value="onepassword"
          />
        </RadioGroup>
      </FormControl>

      {mode === 'onepassword' ? (
        <TextField
          fullWidth
          helperText="e.g. Client credentials/Vendor SFTP"
          label="SFTP 1Password item path"
          onChange={(e) =>
            onChange({
              type: '1password_item',
              '1password_item_path': e.target.value
            })
          }
          required
          value={connection['1password_item_path'] || ''}
          variant="standard"
        />
      ) : (
        <Grid container spacing={2}>
          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              label="Host"
              onChange={(e) =>
                onChange((current) => ({ ...current, host: e.target.value }))
              }
              required
              value={connection.host || ''}
              variant="standard"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              label="Port"
              onChange={(e) =>
                onChange((current) => ({
                  ...current,
                  port: e.target.value === '' ? '' : Number(e.target.value)
                }))
              }
              required
              type="number"
              value={connection.port ?? ''}
              variant="standard"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              label="Username"
              onChange={(e) =>
                onChange((current) => ({
                  ...current,
                  username: e.target.value
                }))
              }
              required
              value={connection.username || ''}
              variant="standard"
            />
          </Grid>
          <Grid item xs={12}>
            <FormControl>
              <RadioGroup
                onChange={(e) => switchKeyMode(e.target.value)}
                row
                value={keyMode}
              >
                <FormControlLabel
                  control={<Radio />}
                  label="Password"
                  value="password"
                />
                <FormControlLabel
                  control={<Radio />}
                  label="Private key"
                  value="key"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          {keyMode === 'password' ? (
            <Grid item md={6} xs={12}>
              <SavedSecretField
                label="SFTP password"
                onChange={(password) =>
                  onChange((current) => ({ ...current, password }))
                }
                secret={connection.password ?? ''}
              />
            </Grid>
          ) : (
            <>
              <Grid item xs={12}>
                <SavedSecretField
                  helperText="PEM private key. Stored encrypted when the job is saved."
                  label="SFTP private key"
                  multiline
                  onChange={(privateKey) =>
                    onChange((current) => ({ ...current, privateKey }))
                  }
                  secret={connection.privateKey ?? ''}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <SavedSecretField
                  label="Key passphrase"
                  onChange={(passphrase) =>
                    onChange((current) => ({ ...current, passphrase }))
                  }
                  required={false}
                  secret={connection.passphrase ?? ''}
                />
              </Grid>
            </>
          )}
        </Grid>
      )}
    </>
  );
};
